<form>
  <h1 mat-dialog-title>{{selectedVendor.name}}</h1>
  <div class="container">
    <div mat-dialog-content>
      
  <div class="mat-elevation-z8">
    <div class="scrollableTable">
      <table mat-table [dataSource]="selectedVendor.publicationMarkets" matSort matSortActive="market" matSortDirection="asc">

        <ng-container matColumnDef="market">
          <th mat-header-cell *matHeaderCellDef mat-sort-header style="width: 80%;"> {{'Maintenance.editVendor.thMarket' | translate}}</th>
          <td mat-cell *matCellDef="let element">{{element.marketName}}</td>
        </ng-container>
        
        <ng-container matColumnDef="delay">
          <th mat-header-cell *matHeaderCellDef mat-sort-header style="width: 10%;"> {{'Maintenance.editVendor.thDelay' | translate}}</th>
          <td mat-cell *matCellDef="let element"><input type="number" matInput [(ngModel)]="element.delay" [ngModelOptions]="{standalone: true}"/></td>
        </ng-container>

        <ng-container matColumnDef="enabled">
          <th mat-header-cell *matHeaderCellDef mat-sort-header style="width: 10%; text-align: center;"> {{'Maintenance.editVendor.thEnabled' | translate}}</th>
          <td mat-cell *matCellDef="let element" style="text-align: center;"><mat-checkbox [(ngModel)]="element.enabled" [ngModelOptions]="{standalone: true}" color="primary"></mat-checkbox></td>
        </ng-container>

        <ng-container matColumnDef="loading">
          <th class="loading" mat-footer-cell *matFooterCellDef colspan="12">{{'tblLoading' | translate}}... </th>
        </ng-container>

        <ng-container matColumnDef="noData">
          <th class="loading" mat-footer-cell *matFooterCellDef colspan="12">{{'Maintenance.tblNoData' | translate}}... </th>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayColumns; sticky: true"></tr>
        <tr mat-row *matRowDef="let row; columns: displayColumns;"></tr>
        <tr mat-footer-row *matFooterRowDef="['loading']" [ngClass]="{'hide':selectedVendor.publicationMarkets!=null}"></tr>
        <tr mat-footer-row *matFooterRowDef="['noData']"
          [ngClass]="{'hide':selectedVendor.publicationMarkets!=null && publicationMarketsLength != 0}"></tr>

      </table>
    </div>
    <mat-paginator [pageSize]="5" [pageSizeOptions]="[5, 10, 25, 50]" [length]="publicationMarketsLength"></mat-paginator>
  </div>
    </div>
    <div mat-dialog-actions>
      <button mat-raised-button color="primary" (click)="OnSaveVendor()">{{'btnOk' | translate}}</button>&nbsp;
      <button mat-raised-button color="secondary" (click)="OnCancel()">{{'btnCancel' | translate}}</button>
    </div>
  </div>
</form>